"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("title", {
      children: "Artboard"
    }), (0, _jsxRuntime.jsxs)("defs", {
      children: [(0, _jsxRuntime.jsxs)("linearGradient", {
        x1: "98.088%",
        y1: ".645%",
        x2: "58.911%",
        y2: "40.825%",
        id: "prefix__a",
        children: [(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#0052CC",
          offset: "17.6%"
        }), (0, _jsxRuntime.jsx)("stop", {
          stopColor: "#2684FF",
          offset: "100%"
        })]
      }), (0, _jsxRuntime.jsxs)("linearGradient", {
        x1: "100.737%",
        y1: ".892%",
        x2: "55.439%",
        y2: "44.724%",
        id: "prefix__b",
        children: [(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#0052CC",
          offset: "17.6%"
        }), (0, _jsxRuntime.jsx)("stop", {
          stopColor: "#2684FF",
          offset: "100%"
        })]
      })]
    }), (0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M27.006 4H15.45a5.21 5.21 0 005.212 5.211h2.125v2.058A5.21 5.21 0 0028 16.48V4.994A.995.995 0 0027.006 4z",
        fill: "#2684FF"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M17.28 5.76H5.726a5.21 5.21 0 005.211 5.211h2.126v2.058a5.21 5.21 0 005.211 5.211V6.754a.995.995 0 00-.994-.994z",
        fill: "url(#prefix__a)",
        transform: "translate(4 4)"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M11.554 11.52H0a5.21 5.21 0 005.211 5.211h2.126v2.058A5.21 5.21 0 0012.55 24V12.514a.995.995 0 00-.995-.994z",
        fill: "url(#prefix__b)",
        transform: "translate(4 4)"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=JiraServer.js.map